import React, { useState, useEffect } from "react";
import "./QuoteCarousel.css";

const QuoteCarousel = ({ locationId, quotes = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isAutoCycling, setIsAutoCycling] = useState(true);

  // If no quotes provided, try to get from location data
  const displayQuotes = quotes.length > 0 ? quotes : [];

  // Start with a random quote and fade in
  useEffect(() => {
    if (displayQuotes.length > 0) {
      const randomIndex = Math.floor(Math.random() * displayQuotes.length);
      setCurrentIndex(randomIndex);
      // Fade in after a short delay
      setTimeout(() => {
        setIsVisible(true);
      }, 100);
    }
  }, [displayQuotes.length]);

  // Auto-cycle through quotes
  useEffect(() => {
    if (!isAutoCycling || displayQuotes.length <= 1) return;

    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % displayQuotes.length);
        setTimeout(() => {
          setIsVisible(true);
        }, 50); // Small delay to ensure content has changed
      }, 1500); // Wait for fade-out to complete
    }, 10000); // Change quote every 10 seconds

    return () => clearInterval(interval);
  }, [isAutoCycling, displayQuotes.length]);

  const handleMouseEnter = () => {
    setIsAutoCycling(false);
  };

  const handleMouseLeave = () => {
    setIsAutoCycling(true);
  };

  if (displayQuotes.length === 0) {
    return null;
  }

  return (
    <div
      className="quote-carousel"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="quote-carousel-content">
        <div className={`quote-text ${isVisible ? "visible" : "hidden"}`}>
          "{displayQuotes[currentIndex]}"
        </div>
      </div>
    </div>
  );
};

export default QuoteCarousel;
